import { memo } from 'react';

import CloseIconSVG from '@/assets/close-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICloseIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CloseIconSVG} {...props} />;

export const CloseIcon = memo(ICloseIcon) as typeof ICloseIcon;
